import React, {useEffect} from "react"
import { CloseIcon } from "../../../icons/Icons";
import "./ImageModal.scss";

type ImageModalProps = {
    source: string;
    closeModal: Function;
    
}

const ImageModal = ({source, closeModal} : ImageModalProps) => {
    
    useEffect(() => {
        const close = (e) => {
          e.stopPropagation();
          if (e.keyCode === 27) {
            closeModal();
          }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
      }, [closeModal]);

    return <div className="ab-test-image-modal-wrapper">
        <div className="image-modal-container">
            <div className="close-icon-container" onClick={()=>{closeModal()}}>
                <CloseIcon width="20" height="20" color="black"/>
            </div>
            <img src={source} alt="" />
        </div>
    </div>
}


export default ImageModal;